import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { NumericInput, PropertyGrid, Selector } from '@leverege/ui-elements';
import Model from "./ResourceImageCustomTextModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const options = [{
  name: 'Baseline',
  value: 'baseline'
}, {
  name: 'Bottom',
  value: 'bottom'
}, {
  name: 'Middle',
  value: 'middle'
}, {
  name: 'Sub',
  value: 'sub'
}, {
  name: 'Super',
  value: 'super'
}, {
  name: 'Text Bottom',
  value: 'text-bottom'
}, {
  name: 'Text Top',
  value: 'text-top'
}, {
  name: 'Top',
  value: 'top'
}];
export default function ResourceImageCustomTextEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  return /*#__PURE__*/_jsxs(PropertyGrid, {
    children: [/*#__PURE__*/_jsx(PropertyGrid.Header, {
      children: "Image Options"
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: "Width",
      children: /*#__PURE__*/_jsx(NumericInput, {
        eventData: "setWidth",
        value: Model.getWidth(value),
        onChange: onModelChange
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: "Height",
      children: /*#__PURE__*/_jsx(NumericInput, {
        eventData: "setHeight",
        value: Model.getHeight(value),
        onChange: onModelChange
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: "Vertical Align",
      children: /*#__PURE__*/_jsx(Selector, {
        eventData: "setVerticalAlign",
        value: Model.getVerticalAlign(value),
        onChange: onModelChange,
        values: options
      })
    })]
  });
}